import { GetCustomerAccountHistoryQuery } from '../../graphql/camel'
import { monthDayYear } from '../../utils/dateTools'
import { formatAsCurrencyOrZero } from '../../utils/priceTools'

type CustomerAccountHistoryTransaction = NonNullable<
  GetCustomerAccountHistoryQuery['getCustomerAccountHistory']
>['transactions'][number]

interface ExportTransactionData {
  date: string
  transaction: string
  charge: string
  payment: string
}

export const transactionsCsvData = (
  transactions: CustomerAccountHistoryTransaction[],
): ExportTransactionData[] =>
  transactions.reduce((acc: ExportTransactionData[], transaction) => {
    if (!transaction) {
      return acc
    }
    acc.push({
      date: monthDayYear(transaction.date),
      transaction: `${transaction.type} #${transaction.transactionNumber}`,
      charge:
        transaction.charge != null ? formatAsCurrencyOrZero({ amount: transaction.charge }) : '',
      payment:
        transaction.payment != null ? formatAsCurrencyOrZero({ amount: transaction.payment }) : '',
    })
    return acc
  }, [])
